import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface Underlying {
  bcsKey: string;
  label: string;
  currency: string;
  isin: string;
  bloombergTicker?: string;
}

interface UnderlyingsResponse {
  underlyings?: Underlying[];
}
export interface GetUnderlyingsByKeys {
  getUnderlyingsByKeys(keys: string[]): Observable<Underlying[]>;
}

export function underlyingsApiConnector(http$: IHttpClient): GetUnderlyingsByKeys {
  return {
    getUnderlyingsByKeys: keys => {
      return http$
        .getJSON<UnderlyingsResponse>({
          url: 'api/v1/secondary-market/underlyings',
          params: {
            keys,
          },
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(r => r.payload.underlyings ?? []));
    },
  };
}
